<template>
  <v-layout column>
    <v-card class="mx-2 pb-2 intro-dark align-center justify-center">
      <v-card-title class="py-3 justify-center prompt-header">
        <mrx-translation :token="updatedPrompt"></mrx-translation>
      </v-card-title>

      <v-card-text class="pb-0">
        <multiselect
          v-model="locations"
          panelName="location"
          panelType="select"
          languagePath="locations"
          :sortAlphabetical=true
          :onClick="handleSelect"
          >
        </multiselect>

        <v-divider v-if="selectionPresent" />

      </v-card-text>

      <v-card-actions
        v-if="selectionPresent"
        class="py-5 justify-center"
      >
        <v-btn
          outlined
          id="reset-locations-button"
          class="reset-warning"
          @click="initialize"
        >
          <mrx-translation token="app.location.button.reset" />
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
  import MultiSelect from '@/components/inputs/MultiSelect'
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    name: 'Location',
    components: {
      multiselect: MultiSelect,
    },
    data() {
      return {
        prompt: `questions.location.prompt`,
      }
    },
    computed: {
      autoProgress() {
        return this.$store.state.settings.engagements_features.autoProgress
      },
      updatedPrompt() {
        const suffix = this.locations[0]?.type || 'location';

        return `${this.prompt}.${suffix}`;
      },
      selectionPresent() {
        return !!this.current
      },
      ...mapGetters('v4/location', {
        current: 'current',
      }),
      ...mapState('v4/location', {
        locations: 'locations',
      }),
    },
    methods: {
      handleSelect(location) {
        this.set(location);
        if (this.autoProgress) {
          this.$nextTick(() => this.update());
        }
      },
      ...mapActions({
        initialize: 'v4/location/initialize',
        set: 'v4/location/set',
        update: 'v4/location/update',
      })
    },
    mounted() {
      // Set/reset initial/root locations on mount
      this.initialize();
    },
  }
</script>

<style scoped></style>
